<template>

  <div>

    <v-card>

      <v-card-title>

        {{ editing
        ? 'Editar Integración de alianza'
        : 'Registrar Integración de alianza'
        }}

      </v-card-title>


      <v-card-text>

        <v-form
          ref="form"
        >

          <!-- Compañía -->
          <v-row>

            <v-col
              cols="12"
              md="4"
            >

              <v-select
                v-model="form.IdCompania"
                :items="filteredClients"
                :rules="[requiredRule]"
                item-text="text"
                item-value="IdCompania"
                label="Compañía"
                prepend-inner-icon="mdi-sitemap"
                :disabled="editing"
              >

                <template v-slot:prepend-item>

                  <v-list-item>

                    <v-list-item-content>

                      <v-text-field
                        v-model="search"
                        hide-details
                        placeholder="Buscar"
                        prepend-inner-icon="mdi-magnify"
                      />

                    </v-list-item-content>

                  </v-list-item>

                </template>

              </v-select>

            </v-col>
            <!-- Alianza -->

              <v-col
                cols="12"
                md="4"
              >

                <v-select
                  v-model="form.CodigoAlianza"
                  :items="availableAlianzas"
                  :rules="[requiredRule]"
                  item-text="NombreAlianza"
                  item-value="CodigoAlianza"
                  label="Alianza"
                  prepend-inner-icon="mdi-handshake"
                  :disabled="editing"
                  @change="changeAlianza"
                />

              </v-col>

          </v-row>


          <!-- Configuración específica -->
          <v-row
            v-if="selectedAlianzaComponent"
          >

            <v-col
              cols="12"
            >

              <component
                :is="selectedAlianzaComponent"
                v-model="form.DataIntegration"
              />

            </v-col>

          </v-row>

          <!-- Botones -->
          <v-row>

            <v-col
              class="d-flex justify-end"
              cols="12"
            >

              <v-btn
                v-if="editing"
                class="mr-3"
                text
                @click="resetForm"
              >
                CANCELAR
              </v-btn>

              <v-btn
                v-if="form.CodigoAlianza"
                dark
                min-width="220"
                height="45"
                style="
        background-color: rgb(204 33 40);
        color: white !important;
      "
                @click="save"
              >
                {{ editing ? 'ACTUALIZAR' : 'GUARDAR' }}
              </v-btn>

            </v-col>

          </v-row>
          <v-alert
            v-show="successAlert"
            type="success"
            text
            class="mb-4"
          >
            {{ msgSuccessAlert }}
          </v-alert>
        </v-form>

      </v-card-text>

    </v-card>

  </div>

</template>


<script>

  import TostaoForm from '../integrations/TostaoForm.vue'

  export default {

    components: {

      TostaoForm,

    },


    data () {

      return {

        editing: false,

        search: '',

        successAlert: false,

        msgSuccessAlert: '',

        form: {

          Id: null,

          IdCompania: '',

          NombreAlianza: '',

          CodigoAlianza: '',

          DataIntegration: {

            username: '',

            password: '',

            url: '',

          },

          Active: true,

        },


        alianzas: [

          {
            NombreAlianza: 'Bonos Tostao ',
            CodigoAlianza: 'HPO-DOC-1',
          },

        ],


        requiredRule: value => {

          if (
            value === null ||
            value === undefined ||
            (
              typeof value === 'string' &&
              !value.trim()
            )
          ) {

            return 'Este campo es obligatorio'

          }

          return true

        },

      }

    },


    computed: {

      detailClients () {

        const clients =
          (
            this.$store.state
              .invoice
              .listClients
              .Mensaje || []
          )
            .filter(
              company =>
                company.Activo === 1,
            )
            .map(company => ({

              ...company,

              text:
                '[' +
                company.IdCompania +
                '] ' +
                company.NombreCompania,

            }))

        return clients

      },


      filteredClients () {

        let clients = this.detailClients

        // Alianzas que ya tiene cada compañía
        clients = clients.filter(
          client => {

            const configuredCodes =
              this.$store.state.alianzas.configs
                .filter(
                  config =>
                    Number(config.IdCompania) ===
                    Number(client.IdCompania),
                )
                .map(
                  config =>
                    config.CodigoAlianza,
                )

            // La compañía se muestra solamente
            // si todavía tiene alguna alianza disponible.
            const hasAvailableAlianza =
              this.alianzas.some(
                alianza =>
                  !configuredCodes.includes(
                    alianza.CodigoAlianza,
                  ),
              )

            return hasAvailableAlianza

          },
        )

        if (!this.search) {
          return clients
        }

        return clients.filter(
          item =>
            item.text
              .toLowerCase()
              .includes(
                this.search.toLowerCase(),
              ),
        )

      },

      availableAlianzas () {

        if (this.editing) {
          return this.alianzas
        }

        if (!this.form.IdCompania) {
          return this.alianzas
        }

        const configuredCodes =
          this.$store.state.alianzas.configs
            .filter(
              config =>
                Number(config.IdCompania) ===
                Number(this.form.IdCompania),
            )
            .map(
              config =>
                config.CodigoAlianza,
            )

        return this.alianzas.filter(
          alianza =>
            !configuredCodes.includes(
              alianza.CodigoAlianza,
            ),
        )

      },

      selectedAlianzaComponent () {

        if (
          this.form.CodigoAlianza === 'HPO-DOC-1'
        ) {

          return TostaoForm

        }

        return null

      },

    },


    async created () {

      await this.$store.dispatch(
        'invoice/getListClients',
      )

      await this.$store.dispatch(
        'alianzas/getConfigs',
      )

    },


    methods: {

      changeAlianza () {

        if (
          this.form.CodigoAlianza === 'HPO-DOC-1'
        ) {

          this.form.NombreAlianza = 'Bonos Tostao'

          this.form.DataIntegration = {

            username: '',

            password: '',

            url: '',

          }

        }

      },


      async save () {

        const isValid =
          this.$refs.form.validate()

        if (!isValid) {
          return
        }

        this.successAlert = false
        this.msgSuccessAlert = ''

        const payload = {

          IdCompania:
          this.form.IdCompania,

          NombreAlianza:
          this.form.NombreAlianza,

          CodigoAlianza:
          this.form.CodigoAlianza,

          DataIntegration:
          this.form.DataIntegration,

          Active:
          this.form.Active,

        }

        let response

        if (this.editing) {

          response =
            await this.$store.dispatch(
              'alianzas/updateConfig',
              {
                id: this.form.Id,
                ...payload,
              },
            )

        } else {

          response =
            await this.$store.dispatch(
              'alianzas/saveConfig',
              payload,
            )

        }

        // Mostrar mensaje del backend
        if (
          response &&
          response.data &&
          response.data.message
        ) {

          this.successAlert = true

          this.msgSuccessAlert =
            response.data.message

          setTimeout(() => {

            this.resetForm()

            this.successAlert = false
            this.msgSuccessAlert = ''

          }, 2000)

        }

        if (
          response &&
          response.data &&
          response.data.data
        ) {

          this.form = {

            ...this.form,

            ...response.data.data,

          }

        }

        this.$emit('refresh')


        if (!this.editing) {

          this.resetForm()

        }

      },


      load (config) {

        this.editing = true

        this.form = {

          Id:
          config.Id,

          IdCompania:
          config.IdCompania,

          NombreAlianza:
          config.NombreAlianza,

          CodigoAlianza:
          config.CodigoAlianza,

          DataIntegration:
            config.DataIntegration || {
              username: '',
              password: '',
              url: '',
            },

          Active:
          config.Active,

        }


        this.$nextTick(() => {

          window.scrollTo({

            top: 0,

            behavior: 'smooth',

          })

        })

      },


      resetForm () {

        this.editing = false

        this.search = ''

        this.form = {

          Id: null,

          IdCompania: '',

          NombreAlianza: '',

          CodigoAlianza: '',

          DataIntegration: {

            username: '',
            password: '',
            url: '',

          },

          Active: true,

        }

        if (this.$refs.form) {

          this.$refs.form.resetValidation()

        }

      },

    },

  }

</script>
